export class NewPrice {

	itemDescription: string;
	itemName: string;
	itemPrice: number;
	itemPriceUnit: string;
	createUser: string;

}